import { Action } from '@/_core/fluxstore/types';
import { CurrentUserState } from '../types';
import { useCurrentUserModule } from '../useModule';

const { registerReducer } = useCurrentUserModule();

export class JiraAuthTokenAdded extends Action<CurrentUserState> {
    public static ACTION_TYPE = 'JiraAuthTokenAdded';
    public constructor() {
        super(JiraAuthTokenAdded.ACTION_TYPE);
    }
}

const reducer = (state: CurrentUserState): void => {
    state.hasJiraAuthToken = true;
};

//@ts-ignore
registerReducer(JiraAuthTokenAdded.ACTION_TYPE, reducer);
